import { ChatBotSettingsFormValues } from "@jugl-web/domain-resources/chat-bot";
import { InteractiveContainer } from "@jugl-web/ui-components";
import { ColorPickerPopover } from "@jugl-web/ui-components/web/ColorPickerPopover/ColorPickerPopover";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { InfoIndicator } from "../../../../../components/InfoIndicator";
import { ChatBotIconPicker } from "../../ChatBotIconPicker";

export const StyleSection: FC = () => {
  const { t } = useTranslations();
  const { control, watch, setValue } =
    useFormContext<ChatBotSettingsFormValues>();

  const handleIconChange = (icon: string | File | null) => {
    setValue("buttonIcon", icon || "default-1", { shouldDirty: true });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <span className="ml-2 font-secondary text-sm text-dark-700">
          {t({
            id: "client-support-page.style",
            defaultMessage: "Icon Style",
          })}
        </span>
        <InfoIndicator
          message={t({
            id: "client-support-page.style-tooltip",
            defaultMessage:
              "Add JPG, PNG, or SVG up to 1MB icon or use existing one",
          })}
        />
      </div>

      <div className="flex flex-col gap-6">
        <ChatBotIconPicker
          icon={watch("buttonIcon")}
          onIconChange={handleIconChange}
        />
        <Controller
          control={control}
          name="buttonColor"
          render={({ field: { value, onChange } }) => (
            <ColorPickerPopover
              title={value}
              color={value}
              onColorChange={onChange}
              renderTrigger={({ Trigger, triggerRef }) => (
                <Trigger
                  ref={triggerRef}
                  as={InteractiveContainer}
                  className="flex h-[60px] items-center gap-3 rounded-[10px] border border-solid border-grey-400 px-5 font-secondary text-sm text-black"
                >
                  <div
                    className="h-6 w-6 rounded-md"
                    style={{ backgroundColor: value }}
                  />
                  <span>
                    {t({
                      id: "cx-ai-agents-page.icon-color",
                      defaultMessage: "Icon color:",
                    })}
                  </span>
                  <span>{value}</span>
                </Trigger>
              )}
            />
          )}
        />
      </div>
    </div>
  );
};
